import { lineSettings } from 'routes/Explore/components/Settings/components/ChartSettingsDrawer/helpers/settingsByViz/line';
import { getMappedColor } from '../helpers/getColor';
import {
    CartesianChartOption,
    CartesianChartType,
} from './CartesianChartOption';
import { EChartsSerie, SerieLabel } from './types';
import { getValidSettings } from './helpers';
import { ChartSettingsT, OrderedColumnsT } from 'business/definitions';

export class LineChartOption extends CartesianChartOption {
    constructor(
        orderedColumns: OrderedColumnsT,
        settings: ChartSettingsT,
        data: ResponseDataT[],
        width: number,
        height: number,
        dataZoomInterval: [number, number] | undefined,
        isPdfModeActivated: boolean,
        isPngModeActivated: boolean,
        isChartViewedOnDashboard: boolean,
    ) {
        // Delete unhandled settings:
        const properSettings = getValidSettings(settings, lineSettings);
        super(
            orderedColumns,
            properSettings,
            data,
            width,
            height,
            dataZoomInterval,
            isPdfModeActivated,
            isPngModeActivated,
            isChartViewedOnDashboard,
        );
    }

    protected getChartType(): CartesianChartType {
        return 'line';
    }

    protected override getLabel(
        serie: EChartsSerie,
        serieIndex: number,
    ): SerieLabel {
        if (serie.type === 'scatter') {
            return {
                ...super.getLabel(serie, serieIndex),
                position: 'top',
            };
        }
        return super.getLabel(serie, serieIndex);
    }

    protected override getSeries(): EChartsSerie[] {
        let series = super.getSeries();

        // Options specific to Lines chart:
        // @ts-expect-error [typing] we don't seem to strictly conform to echart exposed types.
        series = series.map((serie, serieIndex) => ({
            ...serie,
            connectNulls: true,
            smooth: 0.05,
            // Make the hover'd line more visible.
            emphasis: { focus: 'series' },
            blur: { lineStyle: { opacity: 0.25 } },

            // When we use the double axis feature, the main axis is a line,
            // but the secondary axis can become a scatter plot.
            ...(serie.type === 'scatter'
                ? {}
                : // for unclear reasons, echarts hide the labels if the symbol are hidden
                  {
                      symbolSize: this.settings.areLabelsShown ? 0 : 4,
                      showSymbol: !!this.settings.areLabelsShown,
                  }),

            itemStyle: {
                color: getMappedColor(
                    serie.name,
                    serieIndex,
                    this.getCustomColor(serie.name),
                    this.getColor(),
                ),
            },

            areaStyle:
                series.length > 3
                    ? { opacity: 0 }
                    : {
                          opacity: 0.1,
                          color: {
                              type: 'linear',
                              x: 0,
                              y: 0,
                              x2: 0,
                              y2: 1,
                              colorStops: [
                                  {
                                      offset: 0,
                                      color: getMappedColor(
                                          serie.name,
                                          serieIndex,
                                          this.getCustomColor(serie.name),
                                          this.getColor(),
                                      ),
                                  },
                                  { offset: 1, color: 'white' },
                              ],
                          },
                      },
        }));

        return series;
    }
}
